/**
 * Canicule : injecte le wrapper du halo ambiant (cadre viewport).
 * Markup minimal côté JS pour éviter d'éditer layout/theme.liquid (risque de conflit).
 * L'animation et la dégradation reduced-motion sont pilotées par le CSS.
 */
(function () {
  'use strict';

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return;

  function mount() {
    if (document.querySelector('.canicule-ambient-glow')) return;
    var glow = document.createElement('div');
    glow.className = 'canicule-ambient-glow';
    glow.setAttribute('aria-hidden', 'true');
    document.body.appendChild(glow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
